import { faCalendarDay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { listarMaquinas } from "../../../api/maquinas";
import Select from "react-select";
import { registraMantenimiento } from "../../../api/mantenimiento";
import { toast } from "react-toastify";
import queryString from "query-string";
import { LogsInformativos } from "../../logs/logs";

const RegistroMantenimiento = ({ setShow, history }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [listaMaquinas, setListaMaquinas] = useState([]);

  const obtenerEmpleados = () => {
    try {
      listarMaquinas()
        .then((response) => {
          const { data } = response;

          if (!listaMaquinas && data) {
            setListaMaquinas(formatModelMaquinas(data));
          } else {
            const datosMaquinas = formatModelMaquinas(data);
            setListaMaquinas(datosMaquinas);
          }
        })
        .catch((e) => { });
    } catch (e) { }
  };

  useEffect(() => {
    obtenerEmpleados();
  }, []);

  const handleSeleccionChange = (option) => {
    setSelectedOption(option.value);
  };

  const registraMM = (e) => {
    e.preventDefault();

    if (!selectedOption || !fechaInicio || !fechaFin) {
      toast.warning("Datos incompletos");
    } else {
      try {
        const dataTemp = {
          maquina: selectedOption,
          fecha: {
            inicio: fechaInicio,
            fin: fechaFin,
          },
          motivo: observaciones,
          estado: "true",
        };
        registraMantenimiento(dataTemp).then((response) => {
          const { data } = response;
          toast.success("Mantenimiento a máquina registrado");
          LogsInformativos("Se ha registrado el mantenimiento para la maquina " + dataTemp.maquina, dataTemp)
          history({
            search: queryString.stringify(""),
          });
          setShow(false)
        });
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ padding: "2%" }}>
      <Form>
        <div>
          <Row className="mb-2 mb-md-4 mb-lg-7">
            <Col
              sm={12}
              md={4}
              lg={4}
              className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
            >
              <Form.Label>Máquina: <code>*</code></Form.Label>
            </Col>
            <Col sm={12} md={8} lg={8}>
              <Select
                options={listaMaquinas}
                isSearchable={true}
                placeholder={"Seleccionar..."}
                onChange={(selectedOption) =>
                  handleSeleccionChange(selectedOption)
                }
              />
            </Col>
          </Row>
          <Row className="mb-2 mb-md-4 mb-lg-7">
            <Col
              sm={12}
              md={4}
              lg={4}
              className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
            >
              <Form.Label>Fecha de inicio: <code>*</code></Form.Label>
            </Col>
            <Col sm={12} md={8} lg={8}>
              <Form.Control
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mb-2 mb-md-4 mb-lg-7">
            <Col
              sm={12}
              md={4}
              lg={4}
              className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
            >
              <Form.Label>Fecha de fin: <code>*</code></Form.Label>
            </Col>
            <Col sm={12} md={8} lg={8}>
              <Form.Control
                type="date"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mb-2 mb-md-4 mb-lg-7">
            <Col
              sm={12}
              md={4}
              lg={4}
              className="d-flex align-items-start justify-content-start justify-content-md-end justify-content-lg-end"
            >
              <Form.Label>Observaciones:</Form.Label>
            </Col>
            <Col sm={12} md={8} lg={8}>
              <Form.Control
                as="textarea"
                placeholder="Ingresa observaciones en caso de ser necesarias"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </Col>
          </Row>
        </div>
        <div className="divSubmit">
          <Button variant="success" onClick={registraMM} >
            <FontAwesomeIcon icon={faCalendarDay} /> Registrar
          </Button>
        </div>
      </Form>
    </div>
  );
};

const formatModelMaquinas = (data) => {
  return data.map((maquina) => ({
    value: maquina.nombre + " - " + maquina.departamento,
    label: maquina.nombre + " - " + maquina.departamento,
  }));
};

export default RegistroMantenimiento;
